import {
  acquireTokenWithTelemetry,
  endAndReportPerformanceMeasure,
  reportAuthPageLoad,
  reportError,
  reportInfo,
  startPerformanceMeasure,
} from '@ms/yammer-telemetry';
import { checkThirdPartyCookieSupport, reportThirdPartyCookieEvent } from '@ms/yammer-web-support/dist/cookies';
import { isAuthCookieAvailable } from '@ms/yammer-web-support/dist/hosting';
import { isIFrame } from '@ms/yammer-web-support/dist/iframe';
import { authReload, getUrlRootPath } from '@ms/yammer-web-support/dist/location';
import { isInMetaOsHub, notifyAppExpectedFailure } from '@ms/yammer-web-support/dist/metaOsHub';
import { acquireTokenTimeoutInMilliseconds } from 'bootstrap/auth';
import config from 'bootstrap/config';
import { writeCookies } from 'bootstrap/cookies';
import { loadAppErrorRenderer } from 'bootstrap/entries/3-render';

type AuthBootstrap = () => Promise<void>;
const authBootstrap: AuthBootstrap = async () => {
  let endedWithError = false;
  const measure = startPerformanceMeasure('auth_bootstrap');
  const isExecutingInIFrame = isIFrame();
  const isInTeamsApp = await isInMetaOsHub();

  try {
    const yammerToken = await acquireTokenWithTelemetry({
      scopes: [config.adal.resources.yammer],
      timeout: acquireTokenTimeoutInMilliseconds,
      silent: true,
      initiator: 'auth_bootstrap',
    });

    const partitioned = !checkThirdPartyCookieSupport();
    writeCookies(yammerToken, partitioned);
    reportThirdPartyCookieEvent(yammerToken);
  } catch (error: unknown) {
    endedWithError = true;

    notifyAppExpectedFailure(error);
    const render = await loadAppErrorRenderer();
    render({ error, target: document.getElementById('root') as HTMLElement });

    reportError({
      error,
      eventProperties: {
        errorCode: 'AuthBootstrapFailed',
        isInTeamsApp,
        isExecutingInIFrame,
      },
    });

    throw error;
  } finally {
    const urlRootPath = getUrlRootPath(window.location.pathname);

    reportInfo({
      eventName: 'auth_bootstrap_info',
      eventProperties: {
        isExecutingInIFrame,
        isInTeamsApp,
        urlRootPath,
      },
    });

    const eventProperties = { urlRootPath, endedWithError };
    endAndReportPerformanceMeasure({
      ...measure,
      eventProperties: {
        ...measure.eventProperties,
        ...eventProperties,
      },
    });

    reportAuthPageLoad({ eventProperties });
  }

  authReload(!isAuthCookieAvailable());
};

export default authBootstrap;
